import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { catchError, delay, map, switchMap, take, tap } from 'rxjs/operators';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';

@Component({
  selector: 'app-netjets-crossroads',
  templateUrl: './netjets-crossroads.component.html',
  styleUrls: ['./netjets-crossroads.component.scss']
})
export class NetjetsCrossroadsComponent implements OnInit {

  constructor(private commonService: CommonService, private authService: AuthService) { }

  vm$: Observable<any>

  private cmd$ = new BehaviorSubject<ICommand>({ load: true });

  /**
   * 
   */
  refreshPage() {
    this.cmd$.next({ load: true });
    this.authService.userInRole
  }

  /**
   * 
   * @param cmd 
   */
  private mismatchValidateExecute$(cmd: ICommand): Observable<IViewModel> {
    return this.commonService.getData('PageCommand', 'netjets.crossroads', 'mismatch-fixed', { orderNumber: cmd.invokeMismatchValidate.orderNumber }).pipe(
      map((r: IMismatchFixedResult) => {
        if (r.workingText)
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModel = { ...cmd.viewModel, actionsAllowed: true };

        const s = ret.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchValidate.orderNumber);
        s.cmdExecutingText = undefined;

        if (r.errorText) {
          s.cmdExecutedErrorText = r.errorText;
        } else if (r.data && r.data.status == 'ok') {
          s.completedText = 'Validated';
          s.stillWrong = false;
        } else if (r.data && r.data.status == 'mismatch') {
          s.stillWrong = true;
          s.fields = r.data.fields;
        }

        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        const s = ret.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchValidate.orderNumber);
        if (s) {
          s.cmdExecutingText = undefined;
          s.cmdExecutedErrorText = e || 'unkown error';
        }

        return of(ret);
      })
    );
  }

  /**
   * 
   * @param cmd 
   */
  private mismatchIgnoreSubmit$(cmd: ICommand): Observable<IViewModel> {
    
    // required comment
    const s = cmd.viewModel.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchIgnore.orderNumber);
    
    const param = {
      orderNumber: cmd.invokeMismatchIgnore.orderNumber,
      ignore: true,
      ignoreComment: s.ignoreComment
    };
    
    return this.commonService.getData('PageCommand', 'netjets.crossroads', 'mismatch-fixed', param).pipe(
      map((r: IMismatchFixedResult) => {
        if (r.workingText)          
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModel = { ...cmd.viewModel, actionsAllowed: true };

        const s = cmd.viewModel.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchIgnore.orderNumber);
        s.cmdExecutingText = undefined;
        s.ignoreEntrySubmitting = undefined;

        if (r.errorText) {
          s.cmdExecutedErrorText = r.errorText;
        } else if (r.data && r.data.status == 'ok') {
          s.completedText = 'Ignored';
          s.stillWrong = false;
        } else {
          s.completedText = 'Unknown';
        }

        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        const s = ret.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchValidate.orderNumber);
        if (s) {
          s.cmdExecutingText = undefined;
          s.ignoreEntrySubmitting = undefined;
          s.cmdExecutedErrorText = e || 'unkown error';
        }

        return of(ret);
      })
    );
  }

  /**
   * 
   * @param cmd 
   */
  private mismatchIgnoreExecute$(cmd: ICommand): Observable<IViewModel> {
    const ret: IViewModel = { ...cmd.viewModel };

    // work on section
    const s = ret.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchIgnore.orderNumber);
    if (s) {
      if (cmd.invokeMismatchIgnore.state == 1 /* start */) {
        s.ignoreEntryStarted = true;
        ret.actionsAllowed = false;

      } else if (cmd.invokeMismatchIgnore.state == 2 /* submit */) {
        return this.mismatchIgnoreSubmit$(cmd);

      } else if (cmd.invokeMismatchIgnore.state == 3 /* cancel */) {
        s.ignoreEntryStarted = false;
        ret.actionsAllowed = true;

      } 

      return of(ret);
    } else {
      return of(ret);
    }
  }

  /**
   * 
   * @param cmd 
   */
  private inPositionViewExecute$(cmd: ICommand): Observable<IViewModel> {
    return this.commonService.getData('PageCommand', 'netjets.crossroads', 'inposition-viewed', { orderNumber: cmd.invokeInPositionClick.orderNumber}).pipe(
      map((r: ISimpleCommandResult) => {
        if (r.workingText)          
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModel = { ...cmd.viewModel, actionsAllowed: true };

        const row = ret.inPositionIssuesVm.rows.find(r => r.fields[0] == cmd.invokeInPositionClick.orderNumber);
        row.cmdExecutingText = undefined;

        if (r.errorText) {
          row.cmdExecutedErrorText = r.errorText;
        } else if (r.data && r.data.status == 'ok') {
          row.completedText = 'Viewed';
        } else {
          row.completedText = 'Unknown';
        }

        window.open(row.crossroadsUrl, "_blank");

        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        const row = ret.inPositionIssuesVm.rows.find(r => r.fields[0] == cmd.invokeInPositionClick.orderNumber);
        if (row) {
          row.cmdExecutingText = undefined;
          row.cmdExecutedErrorText = e || 'unkown error';
        }

        return of(ret);
      })
    );
  }

  /**
   * 
   * @param cmd 
   * @returns 
   */
  private airportMappingSaveExecute$(cmd: ICommand): Observable<IViewModel> {
    return this.commonService.getData('PageCommand', 'netjets.crossroads', 'airport-mapping-save', { ...cmd.invokeAirportMappingSaveClick }).pipe(
      map((r: ISimpleCommandResult) => {
        if (r.workingText)          
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModel = { ...cmd.viewModel, actionsAllowed: true };

        const ce: ICommandElement = ret.airportMappingEntryVm;
        ce.cmdExecutingText = undefined;

        if (r.errorText) {
          ce.cmdExecutedErrorText = r.errorText;
        } else if (r.data && r.data.status == 'ok') {
          ret.airportMappingEntryVm.data = { iataCode: '', icaoCode: '', faaCode: '' };
          ce.completedText = 'Saved';
        } else {
          ce.completedText = 'Unknown';
        }        

        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        const ce: ICommandElement = ret.airportMappingEntryVm;
        if (ce) {
          ce.cmdExecutingText = undefined;
          ce.cmdExecutedErrorText = e || 'unkown error';
        }

        return of(ret);
      })
    );

  }

  /**
   * 
   * @param cmd 
   */
  private timeZoneValidateExecute$(cmd: ICommand): Observable<IViewModel> {
    return this.commonService.getData('PageCommand', 'netjets.crossroads', 'timezone-fixed', { airportCode: cmd.invokeTimeZoneValidate.airportCode }).pipe(
      map((r: ISimpleCommandResult) => {
        if (r.workingText)
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModel = { ...cmd.viewModel, actionsAllowed: true };

        const s = cmd.viewModel.timeZoneIssuesVm.rows.find(r => r.airportCode == cmd.invokeTimeZoneValidate.airportCode);
        s.cmdExecutingText = undefined;
        s.cmdExecutedErrorText = r.errorText;
        s.completedText = r.data && r.data.status == 'ok' ? 'Validated' : undefined;

        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        const s = cmd.viewModel.timeZoneIssuesVm.rows.find(r => r.airportCode == cmd.invokeTimeZoneValidate.airportCode);
        s.cmdExecutingText = undefined;
        s.cmdExecutedErrorText = e || 'unkown error';

        return of(ret);
      })
    );
  }

  /**
   * 
   * @param orderNumber 
   * @returns 
   */
  private crossroadsUrl(orderNumber: string): string {
    return `https://suppliers.netjets.com/crossroads-ground/crossroads-ground-web/do/groundOrderDetailLoader?id=${orderNumber}`
  }

  /**
   * 
   */
  ngOnInit() {

    this.vm$ = this.cmd$.pipe(
      switchMap(cmd => {
        if (cmd.load) {
          return this.commonService.getData('PageCommand', 'netjets.crossroads', 'page-load').pipe(
            map((v: IViewModel) => {
              if (v.workingText)
                return { ...v };

              const ret = { ...v, actionsAllowed: true };
              if (ret.data) {

                // fixup mismatch panel
                ret.data.mismatchPanel.sections.forEach(s => {
                  s.crossroadsUrl = this.crossroadsUrl(s.orderNumber);
                });

                // fixup new order panel
                if (ret.data.newOrderPanel) {
                  ret.data.newOrderPanel.sections.forEach(s => {
                    s.crossroadsUrl = this.crossroadsUrl(s.orderNumber);
                  });
                }

                // fixup pending order panel
                if (ret.data.pendingOrderPanel) {
                  ret.data.pendingOrderPanel.sections.forEach(s => {
                    s.crossroadsUrl = this.crossroadsUrl(s.orderNumber);
                  });
                }

                // airport mapping entry
                ret.airportMappingEntryVm = ret.data.allowAirportMappingEntry ? {
                  data: {
                    faaCode: '', iataCode: '', icaoCode: ''
                  }
                } : undefined;

                // stat panel 
                ret.statPanelVm = ret.data.statPanel ? {
                    data: ret.data.statPanel
                } : null;;

                // fixup timezone panel
                ret.timeZoneIssuesVm = ret.data.timeZonePanel && !ret.data.timeZonePanel.unauthorized ? {
                  data: ret.data.timeZonePanel,
                  rows: ret.data.timeZonePanel.rows.map(r => ({ airportCode: r[0], fields: r }))
                } : null;

                // in position panel
                ret.inPositionIssuesVm = ret.data.inPositionPanel ? {
                  data: ret.data.inPositionPanel,
                  rows: ret.data.inPositionPanel.rows.map(r => ({ crossroadsUrl: this.crossroadsUrl(r[0]), fields: r }))
                } : null;
              }

              return ret;
            })
          );
        } else {

          return merge(

            // prep
            of(cmd).pipe(
              map(cmd => {
                const ret = { ...cmd.viewModel, actionsAllowed: false };

                if (cmd.invokeMismatchValidate) {
                  ret.data.mismatchPanel.sections.forEach(s => s.cmdExecutedErrorText = undefined);

                  const s = ret.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchValidate.orderNumber);
                  s.cmdExecutingText = 'Validating...';

                } else if (cmd.invokeTimeZoneValidate) {
                  ret.timeZoneIssuesVm.rows.forEach(r => r.cmdExecutedErrorText = undefined);

                  const r = ret.timeZoneIssuesVm.rows.find(r => r.airportCode == cmd.invokeTimeZoneValidate.airportCode);
                  r.cmdExecutingText = 'Validating...';
                } else if (cmd.invokeMismatchIgnore) {
                  ret.data.mismatchPanel.sections.forEach(s => s.cmdExecutedErrorText = undefined);
                  const s = ret.data.mismatchPanel.sections.find(s => s.orderNumber == cmd.invokeMismatchIgnore.orderNumber);

                  if (cmd.invokeMismatchIgnore.state == 1 /* start */) {

                  } else if (cmd.invokeMismatchIgnore.state == 2 /* submit */) {
                    s.cmdExecutingText = 'Ignoring...';                    
                    s.ignoreEntrySubmitting = true;
                    
                  } else if (cmd.invokeMismatchIgnore.state == 3 /* cancel */) {

                  }
                } else if (cmd.invokeInPositionClick) {
                  const row = ret.inPositionIssuesVm.rows.find(r => r.fields[0] == cmd.invokeInPositionClick.orderNumber);
                  row.cmdExecutingText = 'Viewing...';
                
                } else if (cmd.invokeAirportMappingSaveClick) {
                  ret.airportMappingEntryVm.completedText = undefined;
                  ret.airportMappingEntryVm.cmdExecutedErrorText = undefined;
                  ret.airportMappingEntryVm.cmdExecutingText = 'Saving...';
                }

                return ret
              })
            ),

            // invoke API
            of(cmd).pipe(

              // invoke server comand
              switchMap((cmd) => {

                if (cmd.invokeMismatchValidate)
                  return this.mismatchValidateExecute$(cmd);
                else if (cmd.invokeTimeZoneValidate)
                  return this.timeZoneValidateExecute$(cmd);
                else if (cmd.invokeMismatchIgnore)
                  return this.mismatchIgnoreExecute$(cmd);
                else if (cmd.invokeInPositionClick)
                  return this.inPositionViewExecute$(cmd);
                else if (cmd.invokeAirportMappingSaveClick)
                  return this.airportMappingSaveExecute$(cmd);
                else
                  throw 'unknown command';

              })
            )
          );
        }
      })
    );
  }

  /**
   * 
   * @param vm 
   * @param orderNumber 
   */
  mismatchValidateClick(vm: IViewModel, orderNumber: string) {
    this.cmd$.next({ invokeMismatchValidate: { orderNumber: orderNumber }, viewModel: vm })
  }

  /**
   * 
   * @param vm 
   * @param airportCode 
   */
  timeZoneValidateClick(vm: IViewModel, airportCode: string) {
    this.cmd$.next({ invokeTimeZoneValidate: { airportCode: airportCode }, viewModel: vm });
  }

  /**
   * 
   * @param vm 
   * @param orderNumber 
   */
  mismatchIgnoreClick(vm: IViewModel, orderNumber: string, state: number) {
    this.cmd$.next({ invokeMismatchIgnore: { orderNumber: orderNumber, state: state }, viewModel: vm });
  }

  /**
   * 
   * @param vm 
   * @param orderNumber 
   */
  inPositionViewClick(vm: IViewModel, orderNumber: string) {
    this.cmd$.next({ invokeInPositionClick: { orderNumber: orderNumber }, viewModel: vm });
  }

  /**
   * 
   * @param vm 
   */
  airportMappingSaveClick(vm: IViewModel) {
    this.cmd$.next({ invokeAirportMappingSaveClick: { ...vm.airportMappingEntryVm.data }, viewModel: vm });
  }
}

/**
 * 
 */
interface IMismatchFixedResult extends IPageDataViewModel {
  data: { status: string, fields: IOrderPanelSectionFieldData[]; };
}

/**
 * 
 */
interface ISimpleCommandResult extends IPageDataViewModel {
  data: { status: string };
}

/**
 * 
 */
interface IViewModel extends IPageDataViewModel {
  data?: { 
    allowAirportMappingEntry: boolean, 
    statPanel: any, timeZonePanel: ITimeZonePanelData, 
    mismatchPanel: IOrderPanelData, 
    newOrderPanel: IOrderPanelData,
    pendingOrderPanel: IOrderPanelData,
    inPositionPanel: IInPositionPanelData
  };

  timeZoneIssuesVm: ITimeZoneIssuesViewModel;
  inPositionIssuesVm: IInPositionIssuesViewModel;
  statPanelVm: IStatPanelViewModel;

  airportMappingEntryVm: IAirportMappingEntryViewModel;

  actionsAllowed?: boolean;
}

/**
 * 
 */
interface IStatPanelViewModel {
  data: any;
}

/**
 * 
 */
interface IInPositionIssuesViewModel {
  data: IInPositionPanelData
  rows: IInPositionIssuesRowViewModel[];
}

/**
 * 
 */
interface IInPositionIssuesRowViewModel extends ICommandElement {
  crossroadsUrl: string, 
  fields: any[]
}

/**
 * 
 */
interface IInPositionPanelData {
  title: string;
  rows: string[][];
}

/**
 * 
 */
interface ITimeZonePanelData {
  unauthorized: boolean;
  title: string;
  rows: string[][];
}


/**
 * 
 */
interface ITimeZoneIssuesViewModel {
  data: ITimeZonePanelData;

  rows: ITimeZoneIssuesRowViewModel[];
}

/**
 * 
 */
interface ITimeZoneIssuesRowViewModel extends ICommandElement {
  airportCode: string;

  fields: string[];
}

/**
 * 
 */
interface IOrderPanelData {
  title: string;
  sections: IOrderPanelSectionData[];
  type?: string;
}

/**
 * 
 */
interface IOrderPanelSectionData extends ICommandElement {
  orderNumber: string;
  confirmNumber?: string

  fields: IOrderPanelSectionFieldData[];

  stillWrong: boolean;

  ignoreComment: string;
  ignoreEntryStarted: boolean;
  ignoreEntrySubmitting: boolean;

  crossroadsUrl: string;
}

/**
 * 
 */
interface IOrderPanelSectionFieldData {
  name: string;
  crossroadsValue: string;
  santaCruzValue?: string;
}

interface ICommandElement {
  cmdExecutingText?: string;
  cmdExecutedErrorText?: string;
  completedText?: string;
}

/**
 * 
 */
interface ICommand {
  load?: boolean;

  invokeMismatchValidate?: { orderNumber: string };
  invokeTimeZoneValidate?: { airportCode: string };

  invokeMismatchIgnore?: { orderNumber: string, state: number };
  
  invokeInPositionClick?: { orderNumber: string };

  invokeAirportMappingSaveClick?: { iataCode: string, icaoCode: string, faaCode: string };

  viewModel?: IViewModel;
}

/**
 * 
 */
interface IAirportMappingEntryViewModel extends ICommandElement {
  data: any;
}